"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _DataStore = require("../../../KESI2/Stores/DataStore2");

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _ContentStore = _interopRequireDefault(require("../../../KESI2/Stores/ContentStore"));

var _UserProfile = _interopRequireDefault(require("./UserProfile.scss"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _strings = require("./strings");

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var UserProfileForm = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(UserProfileForm, _DataStoreComponent);

  var _super = _createSuper(UserProfileForm);

  function UserProfileForm(props) {
    var _thisSuper, _thisSuper2, _this;

    (0, _classCallCheck2["default"])(this, UserProfileForm);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleChange", function (id) {
      return function (event) {
        var state = _this.state;
        state[id] = event.target.value;

        _this.setState({
          state: state
        });

        _this.props.onHandleChange(id, event.target.value);
      };
    });
    _this.state = {
      firstName: '',
      lastName: '',
      location: '',
      department: '',
      phoneNumber: '',
      salutation: ''
    };
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(UserProfileForm.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.USER_PROFILE]);
    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(UserProfileForm.prototype)), "addStoresAndKeys", _thisSuper2).call(_thisSuper2, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme', 'navbar', 'button']
    }, {
      store: _ContentStore["default"],
      keys: ['content']
    }]);
    return _this;
  }

  (0, _createClass2["default"])(UserProfileForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (_config["default"].isUserProfileComplete()) {
        var userData = this.state.data[_DataStore.DATA_STORE_PATHS.USER_PROFILE];
        this.setState({
          firstName: userData.firstName,
          lastName: userData.lastName,
          location: userData.location,
          department: userData.department,
          phoneNumber: userData.phoneNumber,
          salutation: userData.salutation
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var errorMessageDiv = this.props.errorMessage ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserProfile["default"].error
      }, this.props.errorMessage) : null;
      return /*#__PURE__*/_react["default"].createElement("div", null, errorMessageDiv, /*#__PURE__*/_react["default"].createElement("form", {
        className: _UserProfile["default"].formContainer,
        noValidate: true,
        autoComplete: "off"
      }, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], null, /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], {
        htmlFor: "salutation"
      }, (0, _strings.getString)('SALUTATION')), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
        value: this.state.salutation || this.props.salutation,
        placeholder: (0, _strings.getString)('PLEASE_SELECT'),
        onChange: this.handleChange('salutation'),
        inputProps: {
          id: 'salutation',
          style: {
            minWidth: '200px'
          }
        },
        classes: {
          root: _UserProfile["default"].select
        },
        MenuProps: {
          style: {
            zIndex: 35005
          }
        }
      }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        key: (0, _strings.getString)('MR'),
        value: (0, _strings.getString)('MR')
      }, (0, _strings.getString)('MR')), /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        key: (0, _strings.getString)('MRS'),
        value: (0, _strings.getString)('MRS')
      }, (0, _strings.getString)('MRS')))), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        id: "name",
        label: (0, _strings.getString)('FIRST_NAME'),
        className: _UserProfile["default"].textfield,
        value: this.state.firstName || this.props.firstName,
        onChange: this.handleChange('firstName'),
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        id: "lastname",
        label: (0, _strings.getString)('LAST_NAME'),
        className: _UserProfile["default"].textfield,
        value: this.state.lastName || this.props.lastName,
        onChange: this.handleChange('lastName'),
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        id: "department",
        label: (0, _strings.getString)('DEPARTMENT'),
        className: _UserProfile["default"].textfield,
        value: this.state.department || this.props.department,
        onChange: this.handleChange('department'),
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        id: "location",
        label: (0, _strings.getString)('LOCATION'),
        className: _UserProfile["default"].textfield,
        value: this.state.location || this.props.location,
        onChange: this.handleChange('location'),
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        id: "phoneNumber",
        label: (0, _strings.getString)('PHONE_NUMBER'),
        className: _UserProfile["default"].textfield,
        value: this.state.phoneNumber || this.props.phoneNumber,
        onChange: this.handleChange('phoneNumber'),
        fullWidth: true
      })));
    }
  }]);
  return UserProfileForm;
}(_DataStoreComponent2["default"]);

UserProfileForm.propTypes = {
  errorMessage: _propTypes["default"].string,
  onHandleChange: _propTypes["default"].func,
  firstName: _propTypes["default"].string,
  lastName: _propTypes["default"].string,
  department: _propTypes["default"].string,
  phoneNumber: _propTypes["default"].string,
  salutation: _propTypes["default"].string,
  location: _propTypes["default"].string
};
var _default = UserProfileForm;
exports["default"] = _default;